import { render, staticRenderFns } from "./cate.vue?vue&type=template&id=d8c1394e&scoped=true"
import script from "./cate.vue?vue&type=script&lang=js"
export * from "./cate.vue?vue&type=script&lang=js"
import style0 from "./cate.vue?vue&type=style&index=0&id=d8c1394e&prod&lang=css"
import style1 from "./cate.vue?vue&type=style&index=1&id=d8c1394e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8c1394e",
  null
  
)

export default component.exports